<template>
  <div class="side-menu">
    <div class="logo">
      <router-link to="/"
        ><v-img src="@/assets/logo-adata.svg" width="120px" height="40px"
      /></router-link>
    </div>
    <div class="navigation overflow-y-scroll hide-native-scrollbar">
      <!-- Service & Support -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: $route.fullPath.includes('/support-page') }"
        >
          <router-link :to="{ path: '/support-page' }" class="h5 w-100">
            <v-icon>live_help</v-icon>
            <span class="navigation-item__head__name h5"
              >Service & Support</span
            >
          </router-link>
        </div>
      </div>
    </div>
    <div class="navigation-footer">
      <div class="left">
        <div class="square square-1"></div>
        <div class="square square-2"></div>
        <div class="square square-3"></div>
      </div>
      <div class="right">
        <div class="square square-4"></div>
        <div class="square square-5"></div>
        <div class="square square-6">
          <div class="square square-8"></div>
        </div>
        <div class="square square-7">
          <div class="square square-9"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    // is folder subpage active
    isPageManagementActive: false,
    isProductManagementActive: false,
    isCustomerManagementActive: false,
    isInvestorRelationsActive: false,
    isENewsletterActive: false,
    isAccountManagementActive: false,
    // is folder opend
    isPageManagementOpen: false,
    isProductManagementOpen: false,
    isCustomerManagementOpen: false,
    isInvestorRelationsOpen: false,
    isENewsletterOpen: false,
    isAccountManagementOpen: false,
    // forder sub page
    routesOfPageManagement: [
      'home-page',
      'navigation',
      'bupage',
      'csr-page',
      'carrer-page',
      'contact-worldwide-offices-list',
      'sports-lottery-page',
      'alert-info',
      'privacy',
      'term-of-use',
    ],
    routesOfProductManagement: [
      'category',
      'sub-categories',
      'products',
      'product-download',
    ],
    routesOfCustomerManagement: ['adata-members', 'edm-subscribers'],
    routesOfInvestorRelations: [
      'investor-relations',
      'investor-faq',
      'latest-events',
      'shareholder-meeting',
      'dividend-history',
      'email-alerts',
    ],
    routesOfENewsletter: ['edm-send-list', 'edm-report'],
    routesOfAccountManagement: ['account-list', 'account-log'],
  }),
  computed: {
    currentRoute() {
      return this.$route.fullPath;
    },
  },
  methods: {
    checkPageManagementActive() {
      this.isPageManagementActive = this.routesOfPageManagement.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
    checkProductManagementActive() {
      this.isProductManagementActive = this.routesOfProductManagement.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
    checkCustomerManagementActive() {
      this.isCustomerManagementActive = this.routesOfCustomerManagement.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
    checkInvestorRelationsActive() {
      this.isInvestorRelationsActive = this.routesOfInvestorRelations.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
    checkEnewsletterActive() {
      this.isENewsletterActive = this.routesOfENewsletter.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
    checkAccountManagementActive() {
      this.isAccountManagementActive = this.routesOfAccountManagement.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
  },
  watch: {
    currentRoute() {
      // console.log('from', from);
      // console.log('to', to);
      // console.log(to);
      // console.log('sub', this.$route.matched[0].path.substring(1));
      // console.log('active', this.isPageManagementActive);

      this.checkPageManagementActive();
      this.checkProductManagementActive();
      this.checkCustomerManagementActive();
      this.checkInvestorRelationsActive();
      this.checkEnewsletterActive();
      this.checkAccountManagementActive();
    },
  },
  mounted() {
    this.checkPageManagementActive();
    this.checkProductManagementActive();
    this.checkCustomerManagementActive();
    this.checkInvestorRelationsActive();
    this.checkEnewsletterActive();
    this.checkAccountManagementActive();
  },
};
</script>

<style lang="scss" scoped>
// hide scroll bar, maybe used on navigation
.hide-native-scrollbar {
  scrollbar-width: none; /* Firefox 64 */
  -ms-overflow-style: none; /* Internet Explorer 11 */
  &::-webkit-scrollbar {
    display: none; /** WebKit */
  }
}
.overflow-y-scroll {
  overflow-y: hidden;
  &:hover {
    overflow-y: scroll;
  }
}

.side-menu {
  position: fixed;
  width: 240px;
  height: 100vh;
  background-color: $brand-800;

  a {
    text-decoration: none;
    i {
      text-decoration: none;
    }
  }

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 60px;
    width: 240px;
    height: 50px;
    background-color: #f7fafc;
  }
}
.navigation {
  height: calc(100vh - 50px - 91px);
  padding-top: 20px;
  padding-bottom: 26px;

  &-item {
    &__head {
      display: flex;
      padding: 8px 8px;
      i:first-of-type {
        margin-left: 4px;
        margin-right: 12px;
        color: #b8cdfb;
        font-size: 20px;
      }
      i:not(:first-of-type) {
        margin-left: 4px;
        margin-right: 4px;
        color: #b8cdfb;
        font-size: 20px;
      }
      &__name {
        color: #b8cdfb;
      }
      &:hover,
      &:active,
      &:focus,
      &.hover,
      &.active,
      &.focus {
        font-weight: bold;
        cursor: pointer;
        i {
          color: #ffffff;
        }
        span {
          color: #ffffff;
        }
      }
    }
    &__sub {
      margin-left: 38px;
      &__item {
        display: block;
        height: 36px;
        padding: 8px;
        color: #b8cdfb;
        font-size: 14px;
        a {
          color: #b8cdfb;
        }
        &:hover,
        &.hover {
          font-weight: bold;
          cursor: pointer;
        }
        &:active,
        &.active,
        &.router-link-active,
        .router-link-active {
          font-weight: bold;
          color: white;
          cursor: pointer;
        }
      }
    }
  }
}
.navigation-footer {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 240px;
  height: 91px;

  .square {
    position: absolute;
  }

  .left {
    position: relative;
    margin-top: 27px;
    width: 98px;
    height: 65px;

    .square-1 {
      left: 0;
      width: 27px;
      height: 65px;
      background-color: #88c640;
    }
    .square-2 {
      right: 0px;
      width: 71px;
      height: 25px;
      background-color: #1dafec;
    }
    .square-3 {
      bottom: 0;
      right: 0;
      width: 71px;
      height: 40px;
      background-color: #a3ffd8;
    }
  }
  .right {
    position: relative;
    width: 142px;
    height: 91px;

    .square-4 {
      top: 0;
      left: 0;
      width: 102px;
      height: 51px;
      background-color: #0184f6;
    }
    .square-5 {
      top: 0;
      right: 0;
      width: 40px;
      height: 51px;
      background-color: #1e4292;
    }

    .square-6 {
      bottom: 0;
      left: 0;
      width: 102px;
      height: 40px;
      background-color: #feda4d;
    }

    .square-7 {
      bottom: 0;
      right: 0;
      width: 40px;
      height: 40px;
      background-color: #fd882f;
    }

    .square-8 {
      $radius: 40px;
      bottom: 0;
      right: 0;
      width: $radius;
      height: $radius;
      background-color: #feeba0;
      border-radius: $radius * 2 0 0 0;
    }

    .square-9 {
      $radius: 40px;
      top: 0;
      right: 0;
      width: $radius;
      height: $radius;
      background-color: #fdc090;
      border-radius: 0 $radius * 2 0 0;
    }
  }
}
</style>
